import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private readonly baseUrl = `${environment.apiUrl}${environment.versionApi}/users`;

  constructor(private readonly http: HttpClient) {}

  getClientAppUsers(): Observable<any[]> {
    return this.http.post<any[]>(`${this.baseUrl}/get-client-app-users`, {});
  }

  createClientAppUser(payload: { email: string; nomeCompleto: string }): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/create-client-app-user`, payload);
  }

  removeClientAppUser(email: string): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/remove-client-app-user`, { email });
  }

  getClientAppRoles(): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/role`);
  }

  getUserRoles(userId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/get-user-roles?userId=${userId}`);
  }

  assignRoleToUser(userId: number, roleId: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl}/assing-role-to-user?userId=${userId}&roleId=${roleId}`);
  }

  removeRoleFromUser(userId: number, roleId: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl}/remove-role-from-user?userId=${userId}&roleId=${roleId}`);
  }
}
